import React from 'react';
import { useNavigate } from 'react-router-dom';

const D = {
  bg:      '#0a0a09',
  surface: '#111110',
  surface2:'#161614',
  border:  '#2a2927',
  text:    '#f0ede8',
  text2:   '#a8a49e',
  text3:   '#6b6966',
  accent:  '#c49a3c',
  accentL: 'rgba(196,154,60,0.12)',
  accentB: 'rgba(196,154,60,0.3)',
};

function TablaIcon({ size = 48, color = '#c49a3c' }) {
  const cx = size/2, cy = size/2;
  const r1 = size*0.44, r2 = size*0.34, r3 = size*0.18, r4 = size*0.085, dot = size*0.028;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none">
      <ellipse cx={cx} cy={cy} rx={r1} ry={r1} stroke={color} strokeWidth={size*0.05}/>
      <ellipse cx={cx} cy={cy} rx={r2} ry={r2} stroke={color} strokeWidth={size*0.025}
        strokeDasharray={`${size*0.07} ${size*0.055}`} opacity="0.6"/>
      <ellipse cx={cx} cy={cy} rx={r3} ry={r3} fill={color} opacity="0.9"/>
      <ellipse cx={cx} cy={cy} rx={r4} ry={r4} stroke="#0e0e0d" strokeWidth={size*0.02} opacity="0.45"/>
      <circle cx={cx}    cy={cy-r1} r={dot} fill={color} opacity="0.45"/>
      <circle cx={cx}    cy={cy+r1} r={dot} fill={color} opacity="0.45"/>
      <circle cx={cx-r1} cy={cy}    r={dot} fill={color} opacity="0.45"/>
      <circle cx={cx+r1} cy={cy}    r={dot} fill={color} opacity="0.45"/>
    </svg>
  );
}

const features = [
  { icon: '🎵', title: 'Structured Lessons', desc: 'Organized by Taal and Type — Kaida, Rela, Fixed Compositions and more. Learn at your own pace with video lessons and notation.' },
  { icon: '📝', title: 'Personal Homework', desc: 'Receive custom practice assignments from your teacher with instructions, due dates, and direct feedback on your submissions.' },
  { icon: '📊', title: 'Progress Tracking', desc: 'Your teacher tracks your recitation, writing, and composition progress with detailed notes on areas to improve.' },
  { icon: '🎬', title: 'Media Library', desc: 'Access a personal library of audio and video recordings curated specifically for you by your teacher.' },
  { icon: '💬', title: 'Direct Feedback', desc: 'Comment on lessons and homework assignments. Your teacher responds directly to your questions and submissions.' },
  { icon: '📅', title: 'Schedule & Attendance', desc: 'View upcoming lessons and track your attendance history all in one place.' },
];

const steps = [
  { num: '01', title: 'Sign Up', desc: 'Fill out your details and create your account. Takes less than 2 minutes.' },
  { num: '02', title: 'Get Approved', desc: 'Your teacher reviews your application and approves your access. You\'ll get an email notification.' },
  { num: '03', title: 'Start Learning', desc: 'Log in to your personal portal and access all your lessons, homework, and media.' },
];

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div style={{ background: D.bg, minHeight: '100vh', fontFamily: "'DM Sans', sans-serif", color: D.text }}>

      {/* ── Nav ──────────────────────────────────────────────────────────── */}
      <nav style={{ position: 'sticky', top: 0, zIndex: 100, background: 'rgba(10,10,9,0.95)',
        backdropFilter: 'blur(12px)', borderBottom: `1px solid ${D.border}`,
        padding: '0 5%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '64px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <TablaIcon size={32} color={D.accent}/>
          <div>
            <div style={{ fontSize: '15px', fontWeight: 700, color: D.text, letterSpacing: '-0.3px' }}>RhythMicky</div>
            <div style={{ fontSize: '10px', color: D.text3, letterSpacing: '1px', textTransform: 'uppercase', marginTop: '-2px' }}>Beats Institute</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <button onClick={() => navigate('/login')}
            style={{ background: 'none', border: `1px solid ${D.border}`, color: D.text2,
              padding: '7px 12px', borderRadius: '8px', fontSize: '12px', cursor: 'pointer',
              fontFamily: "'DM Sans', sans-serif" }}>
            Log In
          </button>
          <button onClick={() => navigate('/signup')}
            style={{ background: D.accent, border: 'none', color: '#0e0e0d',
              padding: '7px 12px', borderRadius: '8px', fontSize: '12px', fontWeight: 600,
              cursor: 'pointer', fontFamily: "'DM Sans', sans-serif" }}>
            Sign Up
          </button>
        </div>
      </nav>

      {/* ── Hero ─────────────────────────────────────────────────────────── */}
      <section style={{ padding: 'clamp(48px, 10vw, 100px) 5% clamp(40px, 8vw, 80px)', textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '28px' }}>
          <TablaIcon size={80} color={D.accent}/>
        </div>
        <h1 style={{ fontSize: 'clamp(36px, 6vw, 64px)', fontWeight: 700, letterSpacing: '-1.5px',
          lineHeight: 1.1, margin: '0 0 20px', color: D.text }}>
          Learn Tabla & Dhol<br/>
          <span style={{ color: D.accent }}>with RhythMicky</span>
        </h1>
        <p style={{ fontSize: 'clamp(15px, 2.5vw, 18px)', color: D.text2, lineHeight: 1.7, margin: '0 auto 40px', maxWidth: '560px' }}>
          A private learning portal for students of RhythMicky Beats Institute.
          Access lessons, homework, progress tracking, and direct teacher feedback — all in one place.
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap', padding: '0 10px' }}>
          <button onClick={() => navigate('/signup')}
            style={{ background: D.accent, border: 'none', color: '#0e0e0d',
              padding: '14px 32px', borderRadius: '10px', fontSize: '15px', fontWeight: 600,
              cursor: 'pointer', fontFamily: "'DM Sans', sans-serif" }}>
            Apply for Access →
          </button>
          <button onClick={() => navigate('/login')}
            style={{ background: D.surface2, border: `1px solid ${D.border}`, color: D.text,
              padding: '14px 32px', borderRadius: '10px', fontSize: '15px',
              cursor: 'pointer', fontFamily: "'DM Sans', sans-serif" }}>
            Student Login
          </button>
        </div>
      </section>

      {/* ── Divider ───────────────────────────────────────────────────────── */}
      <div style={{ borderTop: `1px solid ${D.border}`, margin: '0 5%' }}/>

      {/* ── Features ─────────────────────────────────────────────────────── */}
      <section style={{ padding: 'clamp(40px, 8vw, 80px) 5%', maxWidth: '1100px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '52px' }}>
          <div style={{ fontSize: '11px', fontWeight: 600, color: D.accent, letterSpacing: '2px',
            textTransform: 'uppercase', marginBottom: '12px' }}>What You Get</div>
          <h2 style={{ fontSize: 'clamp(26px, 4vw, 40px)', fontWeight: 700, letterSpacing: '-0.8px',
            margin: 0, color: D.text }}>Everything you need to learn</h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(260px, 100%), 1fr))', gap: '16px' }}>
          {features.map((f, i) => (
            <div key={i} style={{ background: D.surface, border: `1px solid ${D.border}`,
              borderRadius: '14px', padding: '24px' }}>
              <div style={{ fontSize: '28px', marginBottom: '14px' }}>{f.icon}</div>
              <h3 style={{ fontSize: '16px', fontWeight: 600, color: D.text, margin: '0 0 8px' }}>{f.title}</h3>
              <p style={{ fontSize: '14px', color: D.text2, lineHeight: 1.6, margin: 0 }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── How it works ─────────────────────────────────────────────────── */}
      <section style={{ padding: 'clamp(40px, 8vw, 80px) 5%', background: D.surface, borderTop: `1px solid ${D.border}`,
        borderBottom: `1px solid ${D.border}` }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '52px' }}>
            <div style={{ fontSize: '11px', fontWeight: 600, color: D.accent, letterSpacing: '2px',
              textTransform: 'uppercase', marginBottom: '12px' }}>Process</div>
            <h2 style={{ fontSize: 'clamp(26px, 4vw, 40px)', fontWeight: 700, letterSpacing: '-0.8px',
              margin: 0, color: D.text }}>How it works</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(200px, 100%), 1fr))', gap: '24px' }}>
            {steps.map((s, i) => (
              <div key={i} style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{ fontSize: '36px', fontWeight: 800, color: D.accentB,
                  letterSpacing: '-1px', marginBottom: '16px', fontVariantNumeric: 'tabular-nums' }}>
                  {s.num}
                </div>
                <h3 style={{ fontSize: '18px', fontWeight: 600, color: D.text, margin: '0 0 10px' }}>{s.title}</h3>
                <p style={{ fontSize: '14px', color: D.text2, lineHeight: 1.6, margin: 0 }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ──────────────────────────────────────────────────────────── */}
      <section style={{ padding: 'clamp(40px, 8vw, 80px) 5%', textAlign: 'center' }}>
        <div style={{ maxWidth: '560px', margin: '0 auto' }}>
          <TablaIcon size={48} color={D.accent}/>
          <h2 style={{ fontSize: 'clamp(26px, 4vw, 40px)', fontWeight: 700, letterSpacing: '-0.8px',
            margin: '20px 0 16px', color: D.text }}>Ready to start learning?</h2>
          <p style={{ fontSize: '16px', color: D.text2, lineHeight: 1.7, margin: '0 0 32px' }}>
            Apply for access today. Your teacher will review your application and get back to you within 24 hours.
          </p>
          <button onClick={() => navigate('/signup')}
            style={{ background: D.accent, border: 'none', color: '#0e0e0d',
              padding: '14px 36px', borderRadius: '10px', fontSize: '15px', fontWeight: 600,
              cursor: 'pointer', fontFamily: "'DM Sans', sans-serif" }}>
            Apply for Access →
          </button>
        </div>
      </section>

      {/* ── Footer ───────────────────────────────────────────────────────── */}
      <footer style={{ borderTop: `1px solid ${D.border}`, padding: '24px 5%',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <TablaIcon size={20} color={D.accent}/>
          <span style={{ fontSize: '13px', color: D.text3 }}>RhythMicky Beats Institute</span>
        </div>
        <p style={{ fontSize: '12px', color: D.text3, margin: 0 }}>
          © {new Date().getFullYear()} RhythMicky Beats Institute. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
